import { EventEmitter } from '../util/eventemitter';

export class QuestDataDailyLog { // quest_completion_data
  dailyQuests: number;
  quests: any[];

  constructor() {
    this.dailyQuests = 0;
    this.quests = [];
  }
}

export class QuestDataItem {
  quest: number;
  item: any;

  constructor() {
    this.quest = 0;
    this.item = null;
  }
}

export class QuestDataVariables {
  episode: any[];
  job: any[];
  planet: any[];
  union: any[];
  switches: any[];

  constructor() {
    this.episode = [];
    this.job = [];
    this.planet = [];
    this.union = [];
    this.switches = [];
  }
}

export class QuestDataQuest {
  id: number;
  expiryTime: number;
  vars: any[];
  switches: any[];

  constructor() {
    this.id = 0;
    this.expiryTime = 0;
    this.vars = [];
    this.switches = [];
  }
}

export class QuestData extends EventEmitter {
  quests: any;
  dailyLog: any;
  vars: any;
  items: any[];
  // Type ID of the NPC currently being talked to, mirrors the server's
  // WorldClient.quest.RefNPC (set by pakNPCClick, read by QSD condition 13).
  refNpc: any;

  static QUEST = {
    EPISODE_VARS: 5,
    JOB_VARS: 3,
    PLANET_VARS: 7,
    UNION_VARS: 10,
    USER_SWITCHES: 512,
    PLAYER_QUESTS: 10,
    QUEST_VARS: 10,
    QUEST_SWITCHES: 32
  };

  static SwitchBitMask = [ 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80 ];

  static DailyLog = QuestDataDailyLog;
  static Item = QuestDataItem;
  static Variables = QuestDataVariables;
  static Quest = QuestDataQuest;

  constructor() {
    super();

    this.quests = null;
    this.dailyLog = null;
    this.vars = null;
    this.refNpc = undefined;
    this.items = [];
  }

setQuests(quests: any) {
    this.quests = quests;
    this.emit("changed");
  }

  setVars(vars: any) {
    this.vars = vars;
    this.emit("changed");
  }

  setItems(items: any) {
    this.items = items;
    this.emit("changed");
  }

  setDailyLog(log: any) {
    this.dailyLog = log;
    this.emit("changed");
  }

  removeQuestAt(slot: any) {
    for (let i = slot; i < this.quests.length - 1; ++i) {
      this.quests[i] = this.quests[i + 1];
    }
    this.quests[this.quests.length - 1] = new QuestData.Quest();
    this.emit("changed");
  }

  getSwitch(id: any) {
    if (id < 0 || id >= QuestData.QUEST.USER_SWITCHES) {
      console.warn('QuestData.getSwitch(' + id + ') id is out of range');
      return -1;
    }

    let switchByte = this.vars.switches[Math.floor(id / 8)];
    let result = (switchByte & QuestData.SwitchBitMask[id & 0x7]) !== 0;

    console.log('QuestData.getSwitch(' + id + ') = ' + result);
    return result ? 1 : 0;
  }

  getEpisodeVar(id: any) {
    if (id < 0 || id >= QuestData.QUEST.EPISODE_VARS) {
      console.warn('QuestData.getEpisodeVar(' + id + ') id is out of range');
      return -1;
    }

    console.log('QuestData.getEpisodeVar(' + id + ') = ' + this.vars.episode[id]);
    return this.vars.episode[id];
  }

  getJobVar(id: any) {
    console.log('QuestData.getJobVar(' + id + ')');

    if (id < 0 || id >= QuestData.QUEST.JOB_VARS) {
      console.warn('QuestData.getJobVar(' + id + ') id is out of range');
      return -1;
    }

    console.log('QuestData.getJobVar(' + id + ') = ' + this.vars.job[id]);
    return this.vars.job[id];
  }

  getPlanetVar(id: any) {
    if (id < 0 || id >= QuestData.QUEST.PLANET_VARS) {
      console.warn('QuestData.getPlanetVar(' + id + ') id is out of range');
      return -1;
    }

    console.log('QuestData.getPlanetVar(' + id + ') = ' + this.vars.planet[id]);
    return this.vars.planet[id];
  }

  getUnionVar(id: any) {
    if (id < 0 || id >= QuestData.QUEST.UNION_VARS) {
      console.warn('QuestData.getUnionVar(' + id + ') id is out of range');
      return -1;
    }

    console.log('QuestData.getUnionVar(' + id + ') = ' + this.vars.union[id]);
    return this.vars.union[id];
  }

  getQuestCount() {
    let count = 0;

    for (let i = 0; i < this.quests.length; ++i) {
      if (this.quests[i].id !== 0) {
        count++;
      }
    }

    console.log('QuestData.getQuestCount() = ' + count);
    return count;
  }

  getQuest(questNo: any) {
    if (questNo < 0 || questNo >= QuestData.QUEST.PLAYER_QUESTS) {
      console.warn('QuestData.getQuest(' + questNo + ') questNo is out of range');
      return null;
    }

    return this.quests[questNo];
  }

  findQuestByID(questID: any) {
    let result = -1;

    for (let i = 0; i < this.quests.length; ++i) {
      if (this.quests[i].id === questID) {
        result = i;
        break;
      }
    }

    console.log('QuestData.findQuestByID(' + questID + ') = ' + result);
    return result;
  }

  getQuestId(questNo: any) {
    if (questNo < 0 || questNo >= QuestData.QUEST.PLAYER_QUESTS) {
      console.warn('QuestData.getQuestId(' + questNo + ') questNo is out of range');
      return -1;
    }

    console.log('QuestData.getQuestId(' + questNo + ') = ' + this.quests[questNo].id);
    return this.quests[questNo].id;
  }

  getQuestItemQuantity(questID: any, type: any, id: any) {
    let count = 0;

    for (let i = 0; i < this.items.length; ++i) {
      const questItem = this.items[i];

      if (questItem.quest === questID) {
        const item = questItem.item;

        if (item.itemNo === id && item.itemType === type) {
          count += item.quantity;
        }
      }
    }

    console.log('QuestData.getQuestItemQuantity(' + questID + ', ' + type + ', ' + id + ') = ' + count);
    return count;
  }

  getQuestSwitch(questNo: any, switchID: any) {
    if (questNo < 0 || questNo >= QuestData.QUEST.PLAYER_QUESTS) {
      console.warn('QuestData.getQuestSwitch(' + questNo + ') questNo is out of range');
      return -1;
    }

    if (switchID < 0 || switchID >= QuestData.QUEST.QUEST_SWITCHES) {
      console.warn('QuestData.getQuestSwitch(' + switchID + ') switch is out of range');
      return -1;
    }

    const switchByte = this.quests[questNo].switches[Math.floor(switchID / 8)];
    let result = (switchByte & QuestData.SwitchBitMask[switchID & 0x7]) !== 0;

    console.log('QuestData.getQuestSwitch(' + questNo + ', ' + switchID + ') = ' + result);
    return result ? 1 : 0;
  }

  getQuestVar(questNo: any, varID: any) {
    if (questNo < 0 || questNo >= QuestData.QUEST.PLAYER_QUESTS) {
      console.warn('QuestData.getQuestVar(' + questNo + ') questNo is out of range');
      return -1;
    }

    if (varID < 0 || varID >= QuestData.QUEST.QUEST_VARS) {
      console.warn('QuestData.getQuestVar(' + varID + ') varID is out of range');
      return -1;
    }

    console.log('QuestData.getQuestVar(' + questNo + ', ' + varID + ') = ' + this.quests[questNo].vars[varID]);
    return this.quests[questNo].vars[varID];
  }

  getQuestTimer(questNo: any) {
    if (questNo < 0 || questNo >= QuestData.QUEST.PLAYER_QUESTS) {
      console.warn('QuestData.getQuestTimer(' + questNo + ') questNo is out of range');
      return -1;
    }

    console.log('QuestData.getQuestTimer(' + questNo + ') = ' + this.quests[questNo].expiryTime);
    return this.quests[questNo].expiryTime;
  }
}

